import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VSelect, {
    attrs: {
      "value": _vm.getByKey('chartOptions.gaugeChart.valueDetermination', 'max'),
      "items": _vm.gaugeValueDeterminations,
      "item-text": "text",
      "item-value": "value",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.valueDetermination.label')
    },
    on: {
      "input": function ($event) {
        return _vm.changeByKey('chartOptions.gaugeChart.valueDetermination', $event);
      }
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VSwitch, {
    attrs: {
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.showDetailValue.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.showDetailValue,
      callback: function ($$v) {
        _vm.showDetailValue = $$v;
      },
      expression: "showDetailValue"
    }
  })], 1), _vm.showDetailValue ? _c(VCol, [_c(VTextField, {
    attrs: {
      "type": "number",
      "min": "0",
      "value": _vm.getByKey('chartOptions.gaugeChart.detailValueDecimalPlaces', 2),
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.detailValueDecimalPlaces.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.changeByKey('chartOptions.gaugeChart.detailValueDecimalPlaces', $event, 'number');
      }
    }
  })], 1) : _vm._e(), _vm.showDetailValue ? _c(VCol, [_c(VCombobox, {
    attrs: {
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.detailValueFormat.label'),
      "hint": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.detailValueFormat.hint'),
      "persistent-hint": "",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.detailValueFormats
    },
    model: {
      value: _vm.detailValueFormat,
      callback: function ($$v) {
        _vm.detailValueFormat = $$v;
      },
      expression: "detailValueFormat"
    }
  })], 1) : _vm._e()], 1), _c(VRow, [_c(VCol, [_c(VSwitch, {
    attrs: {
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.showPointer.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.showPointer,
      callback: function ($$v) {
        _vm.showPointer = $$v;
      },
      expression: "showPointer"
    }
  })], 1), _c(VCol, [_c(VSwitch, {
    attrs: {
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.showAxisLabels.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.showAxisLabels,
      callback: function ($$v) {
        _vm.showAxisLabels = $$v;
      },
      expression: "showAxisLabels"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "type": "number",
      "value": _vm.getByKey('chartOptions.gaugeChart.min', 0),
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.min.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.changeByKey('chartOptions.gaugeChart.min', $event, 'number');
      }
    }
  })], 1), _c(VCol, [_c(VTextField, {
    attrs: {
      "type": "number",
      "value": _vm.getByKey('chartOptions.gaugeChart.max', 100),
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.max.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.changeByKey('chartOptions.gaugeChart.max', $event, 'number');
      }
    }
  })], 1), _c(VCol, [_c(VTextField, {
    ref: "nextThresholdValue",
    attrs: {
      "type": "number",
      "min": _vm.getByKey('chartOptions.gaugeChart.min', 0),
      "max": _vm.getByKey('chartOptions.gaugeChart.max', 100),
      "append-icon": _vm.nextThresholdValue && !isNaN(_vm.nextThresholdValue) ? 'fal fa-add' : null,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.thresholds.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.nextThresholdValueRule]
    },
    on: {
      "click:append": _vm.addThreshold,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.addThreshold.apply(null, arguments);
      }
    },
    model: {
      value: _vm.nextThresholdValue,
      callback: function ($$v) {
        _vm.nextThresholdValue = _vm._n($$v);
      },
      expression: "nextThresholdValue"
    }
  })], 1)], 1), _vm.getByKey('chartOptions.gaugeChart.thresholds', []).length > 0 ? _c('div', [_c(VLabel, [_vm._v("\n      " + _vm._s(_vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.thresholdColors.label')) + "\n    ")]), _c(VRow, _vm._l(_vm.getByKey('chartOptions.gaugeChart.thresholds', []), function (threshold, index) {
    return _c(VCol, {
      key: `threshold-color-input-${index}`,
      staticClass: "text-center"
    }, [_c(VMenu, {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function ({
          on,
          attrs
        }) {
          return [_c(VBtn, _vm._g(_vm._b({
            attrs: {
              "color": threshold.color
            }
          }, 'v-btn', attrs, false), on), [_vm._v("\n              " + _vm._s(_vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.gaugeChart.threshold.color.label', {
            threshold: threshold.value
          })) + "\n              "), _c(VIcon, {
            attrs: {
              "right": ""
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                $event.preventDefault();
                return _vm.removeThreshold(index);
              }
            }
          }, [_vm._v("fal fa-trash")])], 1)];
        }
      }], null, true)
    }, [_c('core-color-picker', {
      attrs: {
        "value": threshold.color
      },
      on: {
        "input": function ($event) {
          return _vm.changeByKey(`chartOptions.gaugeChart.thresholds[${index}].color`, $event, 'string');
        }
      }
    })], 1)], 1);
  }), 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };